<template>
  <div>
    <div class="rj-page-card__title">
      增信措施附件
    </div>
    <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" row-key="id">
      <el-table-column prop="fileName" label="文件名称" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="openContract(row)">
            {{ row.attachmentName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
    </el-table>
  </div>
</template>
<script type="es6">
import { downloadUrl } from '@/API/creditAxios.js';

export default {
  data () {
    return {
      tableData: [],
      tableLoading: false
    };
  },
  props: {
  },
  components: {
  },
  computed: {

  },
  methods: {
    openContract (row) {
      downloadUrl(row.attachmentFileId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data.replace('http://', 'https://'));
        }
      }).catch((res) => {
      });
    },
    setData (data) {
      this.tableData = data;
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
:deep(.el-table){
  border: 1px solid #eef0f3 !important;
  border-bottom: 0 !important;
}
:deep(.el-table th){
  border-right: 0 !important;
}
</style>
